module.exports = __webpack_public_path__ + "img/banner-princiapal.f7af16e7.svg";